import { createContext } from 'react';
import {
  FloatingPanelCollisionStrategy,
  FloatingPanelRegisterFn,
  FloatingPanelUnregisterFn,
  Node,
} from './types';

export interface FloatingPanelContextType<TNode extends Node = Node, TOptions = unknown> {
  registerPanel: FloatingPanelRegisterFn<TOptions>;
  unregisterPanel: FloatingPanelUnregisterFn;
  collisionStrategy: FloatingPanelCollisionStrategy<TNode, TOptions>;
}
export const FloatingPanelContext = createContext<FloatingPanelContextType | null>(null);
